export const PERMISSION_GROUPS = {
  1: {
    label: 'Consultazione di tutti i quesiti',
    privileges: ['view-question', 'view-questions', 'download-pdf'],
    autoDisable: [8,9,10,11]
  },
  2: {
    label: 'Visualizza / aggiungi commento ai quesiti',
    privileges: ['add-comments', 'view-comments', 'download-pdf'],
    autoEnable: [1],
    autoDisable: [8,9,10,11]
  },
  3: {
    label: 'Modifica argomenti / articoli quesito',
    privileges: ['edit-question', 'view-question', 'view-questions', 'download-pdf'],
    autoEnable: [1,2]
  },
  4: {
    label: 'Evasione quesito',
    privileges: ['reply-to-question', 'download-pdf'],
    autoEnable: [1,2,3],
    autoDisable: [8,9,10,11]
  },
  5: {
    label: 'Gestisci quesito',
    privileges: ['assign-question', 'view-question', 'view-questions', 'download-pdf'],
    autoEnable: [1],
    autoDisable: [8,9,10,11]
  },
  6: {
    label: 'Gestisci quesito II livello',
    privileges: ['assign-one-question'],
    autoEnable: [1],
    autoDisable: [5,8,9,10,11]
  },
  7: {
    label: 'Visualizza analisi quesiti',
    privileges: ['view-report', 'download-pdf'],
    autoEnable: [1],
    autoDisable: [8,9,10,11]
  },
  8: {
    label: 'Visualizza UOC',
    privileges: ['view-uoc', 'view-integration', 'download-pdf-uoc', 'download-pdf'],
    autoDisable: [1,2,4,5,6]
  },
  9: {
    label: 'Gestisci UOC',
    privileges: ['manage-uoc', 'add-opinion', 'view-uoc', 'view-integration', 'download-pdf'],
    autoIncludePrivileges: ['view-question', 'edit-question'],
    autoEnable: [8],
    autoDisable: [1,2,4,5,6]
  },
  10: {
    label: 'Visualizza report UOC',
    privileges: ['view-report-uoc', 'download-pdf'],
    autoEnable: [8],
    autoDisable: [1,2,4,5,6]
  },
  11: {
    label: 'Visualizza / aggiungi integrazione',
    privileges: ['add-integration', 'view-integration', 'download-pdf'],
    autoIncludePrivileges: ['view-question', 'edit-question'],
    autoEnable: [8],
    autoDisable: [1,2,4,5,6]
  }
};
